<template>
  <div class="bespread-wrap module-layer5">
    <div class="screen-container">
      <div class="cnt">
        <img src="../../assets/img/layer5/bt.png" alt="" srcset="" class="bt" />
        <div class="r-cnt">
          <swiper :options="featuresOptions" ref="featuresSwiper">
            <swiper-slide v-for="(iconItem, idx) in fList" :key="idx">
              <div class="img-size">
                <img :src="iconItem" alt="" srcset="" />
                <img
                  src="../../assets/img/layer5/gd-hbimg.png"
                  class="gd-hbimg"
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev-role"></div>
          <div class="swiper-button-next-role"></div>
          <div class="swiper-pagination-media"></div>

          <img src="../../assets/img/layer5/fish.png" class="fish" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fList: [
        require("../../assets/img/layer5/1.jpg"),
        require("../../assets/img/layer5/2.jpg"),
        require("../../assets/img/layer5/3.jpg"),
        require("../../assets/img/layer5/4.jpg"),
        require("../../assets/img/layer5/5.jpg")
      ],
      featuresOptions: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper

        allowTouchMove: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 160,
          modifier: 2,
          slideShadows: true
        },
        pagination: {
          el: ".swiper-pagination-media",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active"
        },
        navigation: {
          nextEl: ".swiper-button-next-role",
          prevEl: ".swiper-button-prev-role"
        }
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.module-layer5 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer5/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .screen-container {
    width: calc(100% - 250px);

    .cnt {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 2vw;
      padding-top: 4vw;
    }
    .bt {
      width: 299px;
      height: auto;
    }
    .r-cnt {
      width: 1200px;
      position: relative;
      .fish {
        width: 180px;
        height: auto;
        position: absolute;
        bottom: -7vw;
        right: 4vw;
      }
      .swiper-slide {
        width: 80%;
        height: 100%;
        .img-size {
          width: 994px;
          height: 548px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .gd-hbimg {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      .swiper-button-prev-role:after,
      .swiper-button-next-role:after {
        display: none;
      }

      .swiper-button-prev-role {
        background: url("../../assets/img/layer5/prev.png") no-repeat top;
        background-size: 100% 100%;
        width: 81px;
        height: 78px;
        top: 50%;
        position: absolute;
        z-index: 1;
      }

      .swiper-button-next-role {
        background: url("../../assets/img/layer5/next.png") no-repeat top;
        background-size: 100% 100%;
        width: 81px;
        height: 78px;
        top: 50%;
        right: 0;
        position: absolute;
        z-index: 1;
      }
      /deep/ .swiper-pagination-media {
        position: absolute;
        bottom: -3vw;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1vw;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        .custom-bullet {
          display: inline-block;
          width: 15px;
          height: 15px;
          background-color: #b3b1ad;
        }

        .custom-bullet-active {
          width: 35px;
          height: 35px;
          background: url("../../assets/img/layer5/media-active.png") no-repeat
            top;
            background-size: 100% 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer5 {
   .cnt{
            padding-top:8vw !important;
   } 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer5.vue